"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createParser = exports.chain = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = require("lodash");

var _define = require("./define");

var _match = require("./match");

var _scanner = require("./scanner");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var createNodeByElement = function createNodeByElement(element, parentNode, parentIndex, parser) {
  if (element instanceof Array) {
    var treeNode = new _define.TreeNode(parentIndex);
    treeNode.parentNode = parentNode;
    treeNode.childs = element.map(function (eachElement, childIndex) {
      return createNodeByElement(eachElement, treeNode, childIndex, parser);
    });
    return treeNode;
  }

  if (typeof element === 'string') {
    var matchNode = new _define.MatchNode((0, _match.match)(element)(), {
      type: 'string',
      value: element
    }, parentIndex);
    matchNode.parentNode = parentNode;
    return matchNode;
  }

  if (typeof element === 'boolean') {
    if (element) {
      var trueMatchNode = new _define.MatchNode(_match.matchTrue, {
        type: 'loose',
        value: true
      }, parentIndex);
      trueMatchNode.parentNode = parentNode;
      return trueMatchNode;
    }

    var falseMatchNode = new _define.MatchNode(_match.matchFalse, {
      type: 'loose',
      value: false
    }, parentIndex);
    falseMatchNode.parentNode = parentNode;
    return falseMatchNode;
  }

  if (typeof element === 'function') {
    if (element.parserName === 'match') {
      var _matchNode = new _define.MatchNode(element(), {
        type: 'special',
        value: element.displayName
      }, parentIndex);

      _matchNode.parentNode = parentNode;
      return _matchNode;
    }

    if (element.parserName === 'chainNodeFactory') {
      var chainNode = element(parentNode, null, parentIndex, parser);
      return chainNode;
    }

    var functionNode = new _define.FunctionNode(element, parentIndex, parser);
    functionNode.parentNode = parentNode;
    return functionNode;
  }

  throw Error("unknow element in chain ".concat(element));
};

var chain = function chain() {
  for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) {
    elements[_key] = arguments[_key];
  }

  return function () {
    var solveAst = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (args) {
      return args;
    };

    var chainNodeFactory = function chainNodeFactory(parentNode, creatorFunction) {
      var parentIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var parser = arguments.length > 3 ? arguments[3] : undefined;
      var chainNode = new _define.ChainNode(parentIndex);
      chainNode.parentNode = parentNode;
      chainNode.creatorFunction = creatorFunction;
      chainNode.solveAst = solveAst;
      chainNode.childs = elements.map(function (element, index) {
        return createNodeByElement(element, chainNode, index, parser);
      });

      if (creatorFunction) {
        generateFirstSet(chainNode, parser);
      }

      return chainNode;
    };

    chainNodeFactory.parserName = 'chainNodeFactory';
    return chainNodeFactory;
  };
};

exports.chain = chain;

function getParser(root) {
  if (_define.parserMap.has(root)) {
    return _define.parserMap.get(root);
  }

  var parser = new _define.Parser();
  parser.rootChainNode = root()(null, null, 0, parser);

  _define.parserMap.set(root, parser);

  return parser;
}

function scannerAddCursorToken(scanner, cursorIndex, options) {
  var finalCursorIndex = cursorIndex;

  if (cursorIndex === null) {
    return {
      scanner: scanner,
      finalCursorIndex: finalCursorIndex
    };
  }

  var cursorToken = scanner.getTokenByCharacterIndex(cursorIndex);

  if (!cursorToken) {
    scanner.addToken({
      type: 'cursor',
      value: null,
      position: [cursorIndex, cursorIndex]
    });
  } else if (options.cursorTokenExcludes(cursorToken)) {
    scanner.addToken({
      type: 'cursor',
      value: null,
      position: [cursorIndex + 1, cursorIndex + 1]
    });
    finalCursorIndex += 1;
  }

  return {
    scanner: scanner,
    finalCursorIndex: finalCursorIndex
  };
}

var createParser = function createParser(root, lexer, options) {
  return function (text) {
    var cursorIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    options = (0, _lodash.defaults)(options || {}, new _define.CreateParserOptions());
    var startTime = new Date();
    var tokens = lexer(text);
    var lexerTime = new Date();
    var originScanner = new _scanner.Scanner(tokens);

    var _scannerAddCursorToke = scannerAddCursorToken(new _scanner.Scanner(tokens), cursorIndex, options),
        scanner = _scannerAddCursorToke.scanner,
        finalCursorIndex = _scannerAddCursorToke.finalCursorIndex;

    cursorIndex = finalCursorIndex;
    var parser = getParser(root);
    var cursorPrevToken = scanner.getPrevTokenByCharacterIndex(cursorIndex).prevToken;
    var cursorPrevNodes = cursorPrevToken === null ? [parser.rootChainNode] : [];
    var success = false;
    var ast = null;
    var callVisiterCount = 0;
    var callParentCount = 0;
    var lastMatchUnderShortestRestToken = null;
    newVisit({
      node: parser.rootChainNode,
      scanner: originScanner,
      visiterOption: {
        onCallVisiter: function onCallVisiter(node, store) {
          callVisiterCount += 1;

          if (callVisiterCount > _define.MAX_VISITER_CALL) {
            store.stop = true;
          }
        },
        onVisiterNextNode: function onVisiterNextNode(node, store) {
          callParentCount += 1;

          if (callParentCount > _define.MAX_VISITER_CALL) {
            store.stop = true;
          }
        },
        onMatchNode: function onMatchNode(matchNode, store, currentVisiterOption) {
          var matchResult = matchNode.run(store.scanner);

          if (!matchResult.match) {
            tryChances(matchNode, store, currentVisiterOption);
          } else {
            var restTokenCount = store.scanner.getRestTokenCount();

            if (!lastMatchUnderShortestRestToken || lastMatchUnderShortestRestToken && lastMatchUnderShortestRestToken.restTokenCount > restTokenCount) {
              lastMatchUnderShortestRestToken = {
                matchNode: matchNode,
                token: matchResult.token,
                restTokenCount: restTokenCount
              };
            }

            visitNextNodeFromParent(matchNode, store, currentVisiterOption, _objectSpread({
              token: true
            }, matchResult.token));
          }
        },
        onSuccess: function onSuccess() {
          success = true;
        },
        onFail: function onFail(node) {
          success = false;
        }
      },
      parser: parser
    });
    newVisit({
      node: parser.rootChainNode,
      scanner: scanner,
      visiterOption: {
        onCallVisiter: function onCallVisiter(node, store) {
          callVisiterCount += 1;

          if (callVisiterCount > _define.MAX_VISITER_CALL) {
            store.stop = true;
          }
        },
        onVisiterNextNode: function onVisiterNextNode(node, store) {
          callParentCount += 1;

          if (callParentCount > _define.MAX_VISITER_CALL) {
            store.stop = true;
          }
        },
        onSuccess: function onSuccess() {
          ast = parser.rootChainNode.solveAst ? parser.rootChainNode.solveAst(parser.rootChainNode.astResults) : parser.rootChainNode.astResults;
        },
        onMatchNode: function onMatchNode(matchNode, store, currentVisiterOption) {
          var matchResult = matchNode.run(store.scanner);

          if (!matchResult.match) {
            tryChances(matchNode, store, currentVisiterOption);
          } else {
            if (cursorPrevToken !== null && matchResult.token === cursorPrevToken) {
              cursorPrevNodes.push(matchNode);
            }

            visitNextNodeFromParent(matchNode, store, currentVisiterOption, _objectSpread({
              token: true
            }, matchResult.token));
          }
        }
      },
      parser: parser
    });
    cursorPrevNodes = (0, _lodash.uniq)(cursorPrevNodes);
    var nextMatchNodes = cursorPrevNodes.reduce(function (all, cursorPrevNode) {
      return all.concat(findNextMatchNodes(cursorPrevNode, parser));
    }, []);
    nextMatchNodes = (0, _lodash.uniqBy)(nextMatchNodes, function (each) {
      return each.matching.type + each.matching.value;
    });
    var cursorNextToken = scanner.getNextTokenFromCharacterIndex(cursorIndex);

    if (cursorNextToken) {
      nextMatchNodes = nextMatchNodes.filter(function (nextMatchNode) {
        return !(0, _utils.compareIgnoreLowerCaseWhenString)(nextMatchNode.matching.value, cursorNextToken.value);
      });
    }

    var error = null;

    if (!success) {
      var suggestions = (0, _lodash.uniqBy)((lastMatchUnderShortestRestToken ? findNextMatchNodes(lastMatchUnderShortestRestToken.matchNode, parser) : findNextMatchNodes(parser.rootChainNode, parser)).map(function (each) {
        return each.matching;
      }), function (each) {
        return each.type + each.value;
      });
      var errorToken = lastMatchUnderShortestRestToken && scanner.getNextByToken(lastMatchUnderShortestRestToken.token);

      if (errorToken) {
        error = {
          suggestions: suggestions,
          token: errorToken,
          reason: 'wrong'
        };
      } else {
        error = {
          suggestions: suggestions,
          token: lastMatchUnderShortestRestToken ? lastMatchUnderShortestRestToken.token : null,
          reason: 'incomplete'
        };
      }
    }

    var parserTime = new Date();
    var cursorKeyPath = (0, _utils.getPathByCursorIndexFromAst)(ast, cursorIndex).split('.');
    return {
      success: success,
      ast: ast,
      cursorKeyPath: cursorKeyPath[0] === '' ? [] : cursorKeyPath,
      nextMatchings: nextMatchNodes.reverse().map(function (each) {
        return each.matching;
      }).filter(function (each) {
        return !!each.value;
      }),
      error: error,
      debugInfo: {
        tokens: tokens,
        callVisiterCount: callVisiterCount,
        costs: {
          lexer: lexerTime.getTime() - startTime.getTime(),
          parser: parserTime.getTime() - startTime.getTime()
        }
      }
    };
  };
};

exports.createParser = createParser;

function newVisit(_ref) {
  var node = _ref.node,
      scanner = _ref.scanner,
      visiterOption = _ref.visiterOption,
      parser = _ref.parser;
  var defaultVisiterOption = new _define.VisiterOption();
  (0, _lodash.defaults)(visiterOption, defaultVisiterOption);
  var newStore = new _define.VisiterStore(scanner, parser);
  visit({
    node: node,
    store: newStore,
    visiterOption: visiterOption,
    childIndex: 0
  });
}

var visit = (0, _utils.tailCallOptimize)(function (_ref2) {
  var node = _ref2.node,
      store = _ref2.store,
      visiterOption = _ref2.visiterOption,
      childIndex = _ref2.childIndex;

  if (store.stop) {
    fail(node, store, visiterOption);
    return;
  }

  if (!node) {
    throw Error('no node!');
  }

  if (visiterOption.onCallVisiter) {
    visiterOption.onCallVisiter(node, store);
  }

  if (node instanceof _define.ChainNode) {
    if (firstSetUnMatch(node, store, visiterOption, childIndex)) {
      return;
    }

    visitChildNode({
      node: node,
      store: store,
      visiterOption: visiterOption,
      childIndex: childIndex
    });
  } else if (node instanceof _define.TreeNode) {
    visitChildNode({
      node: node,
      store: store,
      visiterOption: visiterOption,
      childIndex: childIndex
    });
  } else if (node instanceof _define.MatchNode) {
    if (node.matching.type === 'loose') {
      if (node.matching.value === true) {
        visitNextNodeFromParent(node, store, visiterOption, null);
      } else {
        throw Error('Not support loose false!');
      }
    } else {
      visiterOption.onMatchNode(node, store, visiterOption);
    }
  } else if (node instanceof _define.FunctionNode) {
    var functionName = node.chainFunction.name;
    var replacedNode = node.run();
    replacedNode.functionName = functionName;
    node.parentNode.childs[node.parentIndex] = replacedNode;
    visit({
      node: replacedNode,
      store: store,
      visiterOption: visiterOption,
      childIndex: 0
    });
  } else {
    throw Error("Unexpected node type: ".concat(node));
  }
});

function visitChildNode(_ref3) {
  var node = _ref3.node,
      store = _ref3.store,
      visiterOption = _ref3.visiterOption,
      childIndex = _ref3.childIndex;

  if (node instanceof _define.ChainNode) {
    var child = node.childs[childIndex];

    if (child) {
      visit({
        node: child,
        store: store,
        visiterOption: visiterOption,
        childIndex: 0
      });
    } else {
      visitNextNodeFromParent(node, store, visiterOption, visiterOption.generateAst ? node.solveAst(node.astResults) : null);
    }
  } else {
    var _child = node.childs[childIndex];

    if (childIndex + 1 < node.childs.length) {
      addChances({
        node: node,
        store: store,
        visiterOption: visiterOption,
        tokenIndex: store.scanner.getIndex(),
        childIndex: childIndex + 1,
        addToNextMatchNodeFinders: true
      });
    }

    if (_child) {
      visit({
        node: _child,
        store: store,
        visiterOption: visiterOption,
        childIndex: 0
      });
    } else {
      throw Error('tree node unexpect end');
    }
  }
}

var visitNextNodeFromParent = (0, _utils.tailCallOptimize)(function (node, store, visiterOption, astValue) {
  if (store.stop) {
    fail(node, store, visiterOption);
    return;
  }

  if (visiterOption.onVisiterNextNode) {
    visiterOption.onVisiterNextNode(node, store);
  }

  if (!node.parentNode) {
    return noNextNode(node, store, visiterOption);
  }

  if (node.parentNode instanceof _define.ChainNode) {
    if (visiterOption.generateAst) {
      node.parentNode.astResults[node.parentIndex] = astValue;
    }

    visit({
      node: node.parentNode,
      store: store,
      visiterOption: visiterOption,
      childIndex: node.parentIndex + 1
    });
  } else if (node.parentNode instanceof _define.TreeNode) {
    visitNextNodeFromParent(node.parentNode, store, visiterOption, astValue);
  } else {
    throw Error("Unexpected parent node type: ".concat(node.parentNode));
  }
});

function noNextNode(node, store, visiterOption) {
  if (store.scanner.isEnd()) {
    if (visiterOption.onSuccess) {
      visiterOption.onSuccess();
    }
  } else {
    tryChances(node, store, visiterOption);
  }
}

function addChances(_ref4) {
  var node = _ref4.node,
      store = _ref4.store,
      visiterOption = _ref4.visiterOption,
      tokenIndex = _ref4.tokenIndex,
      childIndex = _ref4.childIndex,
      addToNextMatchNodeFinders = _ref4.addToNextMatchNodeFinders;
  var chance = {
    node: node,
    tokenIndex: tokenIndex,
    childIndex: childIndex
  };
  store.restChances.push(chance);
}

function hasParentNodeByFunctionName(node, functionName) {
  if (node instanceof _define.ChainNode && node.functionName === functionName) {
    return true;
  }

  if (node.parentNode) {
    return hasParentNodeByFunctionName(node.parentNode, functionName);
  }

  return false;
}

function tryChances(node, store, visiterOption) {
  if (store.restChances.length === 0) {
    fail(node, store, visiterOption);
    return;
  }

  var nextChance = store.restChances.pop();
  store.scanner.setIndex(nextChance.tokenIndex);
  visit({
    node: nextChance.node,
    store: store,
    visiterOption: visiterOption,
    childIndex: nextChance.childIndex
  });
}

function fail(node, store, visiterOption) {
  if (visiterOption.onFail) {
    visiterOption.onFail(node);
  }
}

function findNextMatchNodes(node, parser) {
  var nextMatchNodes = [];
  var passCurrentNode = false;
  var visiterOption = {
    generateAst: false,
    enableFirstSet: false,
    onMatchNode: function onMatchNode(matchNode, store, currentVisiterOption) {
      if (matchNode === node && passCurrentNode === false) {
        passCurrentNode = true;
        visitNextNodeFromParent(matchNode, store, currentVisiterOption, null);
      } else {
        nextMatchNodes.push(matchNode);
      }

      tryChances(matchNode, store, currentVisiterOption);
    }
  };
  newVisit({
    node: node,
    scanner: new _scanner.Scanner([]),
    visiterOption: visiterOption,
    parser: parser
  });
  return nextMatchNodes;
}

function firstSetUnMatch(node, store, visiterOption, childIndex) {
  if (visiterOption.enableFirstSet && node.creatorFunction && childIndex === 0 && store.parser.firstSet.has(node.creatorFunction)) {
    var firstMatchNodes = store.parser.firstSet.get(node.creatorFunction);

    if (!firstMatchNodes.some(function (firstMatchNode) {
      return firstMatchNode.run(store.scanner, false).match;
    })) {
      tryChances(node, store, visiterOption);
      return true;
    }

    return false;
  }
}

function generateFirstSet(node, parser) {
  if (parser.firstSet.has(node.creatorFunction)) {
    return;
  }

  var firstMatchNodes = getFirstOrFunctionSet(node, node.creatorFunction, parser);
  parser.firstOrFunctionSet.set(node.creatorFunction, firstMatchNodes);
  solveFirstSet(node.creatorFunction, parser);
}

function getFirstOrFunctionSet(node, creatorFunction, parser) {
  if (node instanceof _define.ChainNode) {
    if (node.childs[0]) {
      return getFirstOrFunctionSet(node.childs[0], creatorFunction, parser);
    }
  } else if (node instanceof _define.TreeNode) {
    return node.childs.reduce(function (all, next) {
      return all.concat(getFirstOrFunctionSet(next, creatorFunction, parser));
    }, []);
  } else if (node instanceof _define.MatchNode) {
    return [node];
  } else if (node instanceof _define.FunctionNode) {
    if (parser.relatedSet.has(node.chainFunction)) {
      parser.relatedSet.get(node.chainFunction).add(creatorFunction);
    } else {
      parser.relatedSet.set(node.chainFunction, new Set([creatorFunction]));
    }

    return [node.chainFunction];
  } else {
    throw Error("Unexpected node: ".concat(node));
  }
}

function solveFirstSet(creatorFunction, parser) {
  if (parser.firstSet.has(creatorFunction)) {
    return;
  }

  var firstMatchNodes = parser.firstOrFunctionSet.get(creatorFunction);
  var newFirstMatchNodes = firstMatchNodes.reduce(function (all, firstMatchNode) {
    if (typeof firstMatchNode === 'string') {
      if (parser.firstSet.has(firstMatchNode)) {
        all = all.concat(parser.firstSet.get(firstMatchNode));
      } else {
        all.push(firstMatchNode);
      }
    } else {
      all.push(firstMatchNode);
    }

    return all;
  }, []);
  parser.firstOrFunctionSet.set(creatorFunction, newFirstMatchNodes);

  if (newFirstMatchNodes.every(function (firstMatchNode) {
    return firstMatchNode instanceof _define.MatchNode;
  })) {
    parser.firstSet.set(creatorFunction, newFirstMatchNodes);

    if (parser.relatedSet.has(creatorFunction)) {
      var relatedFunctionNames = parser.relatedSet.get(creatorFunction);
      relatedFunctionNames.forEach(function (relatedFunctionName) {
        return solveFirstSet;
      });
    }
  }
}